export default __webpack_public_path__ + "assets/images/platforms/c430b0658a164a8e089ba18b943e60d2.png";